<template>
  <div :class="$style.tableContainer">
    <table
      :class="[
        $style.table,
        $style.tableWithoutSelectColumn
      ]"
    >
      <thead>
        <tr>
          <th :class="$style.tableHeadCell">
            Name
          </th>
          <th :class="$style.tableHeadCell">
            Description
          </th>
          <th :class="$style.tableHeadCell" />
        </tr>
      </thead>
      <tbody
        v-if="renderTable"
        :class="$style.table"
      >
        <template v-for="policy in policyData">
          <tr
            :key="`bodyRow-${policy.title}`"
            :class="$style.tableBodyRow"
          >
            <td :class="$style.tableBodyCell">
              <span :class="$style.dataFieldText">
                {{ policy.title }}
              </span>
            </td>
            <td :class="$style.tableBodyCell">
              <div :class="$style.description">
                {{ policy.description }}
              </div>
            </td>
            <td :class="$style.tableBodyCell">
              <p :class="$style.availability">
                <span
                  :class="$style.configureForText"
                >
                  Configure for:
                </span>
                <a
                  v-for="system in policy.availability"
                  :key="system.title"
                  :class="$style.systemLink"
                  :href="system.href"
                >
                  {{ system.title }}
                </a>
              </p>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <LoadingOverlay
      :showLoadingOverlay="!renderTable"
      :zIndex="Number(itemTableZIndex) + 1"
    />
  </div>
</template>

<script>
import { itemTableZIndex } from 'client/css/z-index.css';
import LoadingOverlay from 'client/components/LoadingOverlay/LoadingOverlay.vue';
import RecommendedPoliciesMixin from 'client/policies/RecommendedPoliciesMixin';

export default {
  name: 'RecommendedPoliciesItemTable',

  components: {
    LoadingOverlay,
  },

  mixins: [
    RecommendedPoliciesMixin,
  ],

  props: {
    gettingStartedItemType: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      itemTableZIndex,
      itemType: this.gettingStartedItemType,
      renderTable: false,
    };
  },

  async created() {
    await this.initRemainingPolicies();
    this.renderTable = true;
  },
};
</script>

<style scoped module>
@import '../../components/ItemTable/css/ItemTable.css';

.availability {
  font-weight: 700;
  line-height: 1;
}

.systemLink {
  display: inline-block;
  margin-right: 5px;
  text-decoration: underline;
}

.table,
.tableHeadCell,
.tableBodyCell {
  padding-left: 20px;
}

.tableBodyCell {
  min-width: 200px;
}

.tableBodyCell:last-child {
  min-width: 165px;
  padding-right: 20px;
}
</style>
